enum BodyImageNameType {
  signature = 'signature',
  customer_image = 'customer_image',
  adjuster_image = 'adjuster_image',
}

export enum BodyVehicleCorrectiveImageNameType {
  documents = 'documents',
  damaged_parts = 'damaged_parts',
  vehicle = 'vehicle',
}
enum BodyAdjusterImageNameType {
  document_image = 'document_image',
  additional_image = 'additional_image',
  vehicle_image = 'vehicle_image',
}
export type BodyImageTabType = {
  name: BodyImageNameType;
  fa_name: string;
  editable: boolean;
  exists: boolean;
  label: { const: string; fa_const: string } | null;
  is_card_active: true;
  count: number;
};

export type BodyDamagedVehicleCorrectiveImageTabType = {
  name: BodyVehicleCorrectiveImageNameType;
  fa_name: string;
  editable: boolean;
  exists: boolean;
};

export type BodyAdjusterImageTabType = {
  name: BodyAdjusterImageNameType;
  fa_name: string;
  editable: boolean;
  exists: boolean;
  is_card_active: true;
};

export type BodyGetPreviousCorrectiveImageResponse = {
  damaged: {
    id: string;
    title: { const: string; fa_const: string };
    part_id: number;
    side_id: number;
    side_name: { const: string; fa_const: string };
  }[];
  documents: { id: number; title: { const: string; fa_const: string } }[];
  vehicle: { id: number; title: { const: string; fa_const: string } }[];
};
